'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _ = require('..');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __rest = undefined && undefined.__rest || function (s, e) {
    var t = {};
    for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    }if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
};

var DEFAULT_CLASS = 'luna-tabpanel';

var TabPanel = function (_Component) {
    _inherits(TabPanel, _Component);

    function TabPanel() {
        _classCallCheck(this, TabPanel);

        var _this = _possibleConstructorReturn(this, (TabPanel.__proto__ || Object.getPrototypeOf(TabPanel)).apply(this, arguments));

        _this.node = null;
        _this.componentDidUpdate = function () {
            _this.checkFocus();
        };
        _this.checkFocus = function () {
            var selected = _this.props.selected;

            if (selected && _this.node) {
                _this.node.focus();
            }
        };
        _this.handleAccordionChange = function (e) {
            var _this$props = _this.props,
                onAccordionChange = _this$props.onAccordionChange,
                tabId = _this$props.tabId;

            onAccordionChange(tabId, e);
        };
        return _this;
    }

    _createClass(TabPanel, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            this.checkFocus();
        }
    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var _a = this.props,
                children = _a.children,
                className = _a.className,
                forceRender = _a.forceRender,
                id = _a.id,
                selected = _a.selected,
                selectedClassName = _a.selectedClassName,
                tabId = _a.tabId,
                toAccordion = _a.toAccordion,
                accordionTitle = _a.accordionTitle,
                onAccordionChange = _a.onAccordionChange,
                onKeyDown = _a.onKeyDown,
                accordionDisabled = _a.accordionDisabled,
                attributes = __rest(_a, ["children", "className", "forceRender", "id", "selected", "selectedClassName", "tabId", "toAccordion", "accordionTitle", "onAccordionChange", "onKeyDown", "accordionDisabled"]);
            var content = _react2.default.createElement("div", Object.assign({}, attributes, { className: (0, _classnames2.default)(className, _defineProperty({}, selectedClassName, selected)), role: "tabpanel", id: id, "aria-labelledby": tabId }), forceRender || selected ? children : null);
            return toAccordion ? _react2.default.createElement("div", { className: (0, _classnames2.default)('luna-accordion', { 'is-open': selected }) }, _react2.default.createElement("div", { className: "luna-accordion__summary" }, _react2.default.createElement("h5", { className: "luna-accordion__heading" }, _react2.default.createElement("button", { type: "button", className: "luna-accordion__action", "aria-expanded": selected, "aria-controls": id, ref: function ref(button) {
                    _this2.node = button;
                }, onClick: this.handleAccordionChange, onKeyDown: onKeyDown, "aria-disabled": accordionDisabled && accordionDisabled.toString(), disabled: accordionDisabled }, _react2.default.createElement("span", { className: "luna-accordion__title" }, accordionTitle), !selected && _react2.default.createElement(_.Icon, { name: "chevron-down" })))), _react2.default.createElement("div", { className: "luna-accordion__details", "aria-hidden": !selected, id: id }, content)) : content;
        }
    }]);

    return TabPanel;
}(_react.Component);

exports.default = TabPanel;

TabPanel.defaultProps = {
    className: DEFAULT_CLASS,
    forceRender: false,
    selectedClassName: DEFAULT_CLASS + '--selected'
};
TabPanel.propTypes = {
    children: _propTypes2.default.node.isRequired,
    className: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.array, _propTypes2.default.object]),
    forceRender: _propTypes2.default.bool,
    id: _propTypes2.default.string.isRequired,
    selected: _propTypes2.default.bool.isRequired,
    selectedClassName: _propTypes2.default.string,
    tabId: _propTypes2.default.string.isRequired,
    accordionDisabled: _propTypes2.default.bool.isRequired,
    onAccordionChange: _propTypes2.default.func.isRequired,
    toAccordion: _propTypes2.default.bool.isRequired,
    accordionTitle: _propTypes2.default.string.isRequired,
    onKeyDown: _propTypes2.default.func.isRequired
};
//# sourceMappingURL=TabPanel.js.map


// WEBPACK FOOTER //
// ./node_modules/luna-react/dist/components/Tabs/TabPanel.js